import React from 'react';

const Stockadjustmentupdate = () => {
  return <div>Stockadjustmentupdate</div>;
};

export default Stockadjustmentupdate;
